export function isAllowedValue(
  floatValue: number | undefined,
  max: string | number | undefined,
  decimalScale: number | undefined,
): boolean {
  if (floatValue === undefined) return true;
  if (max !== undefined && floatValue > Number(max)) return false;
  if (decimalScale === 0 && floatValue % 1 !== 0) return false;
  return true;
}

export function clampOnBlur(
  latestValue: number | undefined,
  min: string | number | undefined,
  max: string | number | undefined,
  onChange: (value: number | undefined) => void,
): void {
  if (latestValue === undefined) {
    if (min !== undefined) onChange(Number(min));
    return;
  }
  if (min !== undefined && latestValue < Number(min)) {
    onChange(Number(min));
    return;
  }
  if (max !== undefined && latestValue > Number(max)) {
    onChange(Number(max));
    return;
  }
}
